import type { ReactNode } from 'react';

// One label/value row: label on the left, content on the right, divider between
// rows. Stacks on narrow screens; two columns at sm and up. (Same idiom as the
// company information panel.)
export function InfoRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div
      className="grid grid-cols-1 gap-1 border-b border-slate-100 py-3 last:border-b-0
                 sm:grid-cols-[minmax(160px,32%)_1fr] sm:items-center sm:gap-4"
    >
      <div className="text-sm text-slate-500">{label}</div>
      <div className="text-sm">{children}</div>
    </div>
  );
}

// Read-only value: bold when present, an italic "Not provided" when empty.
export function ReadOnlyValue({ value }: { value: string | null }) {
  return value && value.trim().length > 0 ? (
    <span className="font-medium text-slate-900">{value}</span>
  ) : (
    <span className="italic text-slate-400">Not provided</span>
  );
}
